import * as actionTypes from '../actions/actionTypes'

const initialState = {
  search: {
    response: {},
    isLoading: false,
    isError: false
  },
  restrict: {
    response: {},
    isLoading: false,
    isError: false
  },
  unRestrict: {
    response: {},
    isLoading: false,
    isError: false
  }
}

const memberAccessReducer = (state = initialState, action = {}) => {
  const newState = { ...state }
  switch (action.type) {
    case actionTypes.SEARCH_MEMBERS_ACCESS:
      return { ...newState, search: { ...newState.search, isLoading: true } }

    case actionTypes.SEARCH_MEMBERS_ACCESS_SUCCESS:
      return { ...newState, search: { response: { ...action.payload }, isLoading: false, isError: false } }

    case actionTypes.SEARCH_MEMBERS_ACCESS_FAILURE:
      return { ...newState, search: { response: { ...action.payload }, isLoading: false, isError: true } }

    case actionTypes.MEMBER_ACCESS_RESRICT:
      return { ...newState, restrict: { ...newState.restrict, isLoading: true } }

    case actionTypes.MEMBER_ACCESS_RESRICT_SUCCESS:
      return { ...newState, restrict: { response: { ...action.payload }, isLoading: false, isError: false } }

    case actionTypes.MEMBER_ACCESS_RESRICT_FAILURE:
      return { ...newState, restrict: { response: { ...action.payload }, isLoading: false, isError: true } }

    case actionTypes.MEMBER_ACCESS_UNRESRICT:
      return { ...newState, unRestrict: { ...newState.unRestrict, isLoading: true } }

    case actionTypes.MEMBER_ACCESS_UNRESRICT_SUCCESS:
      return { ...newState, unRestrict: { response: { ...action.payload }, isLoading: false, isError: false } }

    case actionTypes.MEMBER_ACCESS_UNRESRICT_FAILURE:
      return { ...newState, unRestrict: { response: { ...action.payload }, isLoading: false, isError: true } }

    default:
      return { ...newState }
  }
}

export default memberAccessReducer
